module.exports = __webpack_public_path__ + "304339cc93b3aa69c556f3ad471f1047.svg";